import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export const getLenis = () => lenisInstance;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -110, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, wheelMultiplier: 0.95 });
    lenisInstance = lenis;
    let frame;
    const loop = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(loop);
    };
    frame = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}
